import Axios from './axios_wrapper'

export function getAccessCode(user_id) {
  return Axios({
    url: `/users/${user_id}/access_code`,
    method: 'GET'
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/access_codes.js
// module id = null
// module chunks = 